<div class="mb-10">
  <h2 class="text-xl font-bold leading-8 text-blue-900">
    Review Your Service {{ isResidentialService() ? 'Order' : 'Request' }}
  </h2>
  <p class="text-gray-750 text-base">
    Please review your service {{ isResidentialService() ? 'order' : 'request' }} details before submitting. We will
    contact you to confirm your service.
  </p>
</div>

<div class="mb-8 flex flex-col gap-y-6 self-stretch md:flex-row md:gap-6">
  <div class="flex gap-4 md:basis-1/2 md:flex-col">
    <i
      class="g-filter-green-600 block h-8 w-8 min-w-8 bg-[url(../assets/icons/profile.svg)] bg-center bg-no-repeat px-1 py-1.5"
    ></i>

    <div class="flex flex-grow flex-col gap-y-1 text-sm text-blue-900">
      <h3 class="break-all text-xs text-gray-800">Customer Information</h3>
      @if (companyName$$()) {
        <div data-testid="info-companyName">{{ companyName$$() }}</div>
      }
      <div class="break-all" data-testid="info-name">{{ name$$() }}</div>
      <div data-testid="info-phoneNumber">{{ personalDetails$$().phone | phone }}</div>
      <div class="break-all" data-testid="info-email">{{ personalDetails$$().email }}</div>
    </div>
  </div>

  <div class="flex gap-4 md:basis-1/2 md:flex-col">
    <i class="g-filter-green-600 block h-8 w-8 min-w-8 bg-[url(../assets/icons/billing.svg)]"></i>

    <div class="flex flex-grow flex-col gap-y-1 text-sm text-blue-900">
      <h3 class="text-xs text-gray-800">Billing Address</h3>
      @if (personalAddress$$().street) {
        <div data-testid="info-street">{{ personalAddress$$().street }}</div>
      } @else {
        <div class="break-all" data-testid="info-poBoxNumber">{{ personalAddress$$().poBoxNumber }}</div>
      }
      @if (personalAddress$$().street2) {
        <div class="break-all" data-testid="info-street2">{{ personalAddress$$().street2 }}</div>
      }
      <div data-testid="info-city">{{ personalAddress$$().city }}</div>
      <div data-testid="info-state">{{ personalAddress$$().state + ' ' + personalAddress$$().zip }}</div>
    </div>
  </div>
</div>

<ng-content><!-- there are service details --></ng-content>

<div class="mb-8 flex flex-col gap-y-4 self-stretch rounded-2xl bg-gray-100 p-4">
  <div class="flex flex-grow gap-2.5" e2e-question-code="confirmOrder" e2e-render-type="boolean-checkbox">
    <input
      class="checkbox !mt-0.5 flex-shrink-0"
      type="checkbox"
      id="confirmOrder"
      [checked]="confirmOrder$$()"
      (change)="toggleConfirmOrder($any($event.target).checked)"
      aria-required="true"
    />

    <label for="confirmOrder" class="!text-base !font-normal text-blue-900" cslLabel required e2e-required="true">
      By confirming this service {{ isResidentialService() ? 'order' : 'request' }}, I agree to receive electronic bills
      via email</label
    >
  </div>

  <div class="flex flex-grow gap-2.5" e2e-question-code="confirmPromo" e2e-render-type="boolean-checkbox">
    <input
      class="checkbox !mt-0.5 flex-shrink-0"
      type="checkbox"
      id="confirmPromo"
      [checked]="confirmPromo$$()"
      (change)="toggleConfirmPromo($any($event.target).checked)"
    />

    <label for="confirmPromo" class="text-base text-blue-900">
      I agree to receive news, promotions, and marketing communications by email from Casella
    </label>
  </div>
</div>
